import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import i18n from "@/core/plugins/i18n";

import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import { DatePicker } from "v-calendar";
import "v-calendar/style.css";

import MomentTimeZone from "moment-timezone";

MomentTimeZone();

import "@/core/plugins/keenthemes";

import "../node_modules/ag-grid-community/styles/ag-grid.css";
import "../node_modules/ag-grid-community/styles/ag-theme-alpine.css";

import "bootstrap";

const app = createApp(App);

app.component("DatePicker", DatePicker);

app.use(store);
import router from "./router";
app.use(router);
import ApiService from "@/core/services/ApiService";
ApiService.init(app);

initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
